import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
const windowGlobal = typeof window !== 'undefined' && window;

const withEventTracking = (event, callback) => () => {
  switch (event) {
    case 'ENTER_DETAILS': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'Register',
        label: 'Enter Details [on Form - Pop-up 2nd view]',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660356 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-Reigster');
      }
      break;
    }

    case 'INCREMENT':
    case 'DECREMENT': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'Bookticket',
        label: 'Select tickets [on Form - Pop-up 1st view]',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660348 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-BookTicket');
      }
      break;
    }

    case 'HACKATHON':
    case 'MASTERCLASS': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'registernow',
        label: 'Whats More',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660340 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-RegisterNow');
      }
      break;
    }

    case 'HERO_SECTION': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'Bookticket',
        label: 'Hero Section',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660324 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-BookTicket');
      }

      break;
    }
    case 'TYPER_SECTION': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'registernow',
        label: '2nd Fold',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660332 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-RegisterNow');
      }

      break;
    }
    case 'REVIEW_DETAILS': {
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'Checkout',
        label: 'Review Tickets [on Form - Pop-up 3rd view]',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5660364 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'FTX2021Paid-Checkout');
      }

      break;
    }
    case 'SUCCESS': {
      trackCustomEvent({
        category: 'TicketDetails_FtX2021',
        action: 'submit',
        label: 'FTX2021',
      });
      trackCustomEvent({
        category: 'FTX2021_Paid',
        action: 'Back to FTX',
        label: 'Success',
      });
      if (windowGlobal.lintrk) {
        windowGlobal.lintrk('track', { conversion_id: 5426436 });
      }
      if (windowGlobal.fbq) {
        windowGlobal.fbq('track', 'TicketDetails-Submit-FTX2021');
      }

      break;
    }

    default:
    /* do nothing */
  }

  if (callback) {
    callback();
  }
};

export { withEventTracking };
